export type Occupant = 'small_children' | 'pre_teens' | 'teens' | 'adult_children' | 'adults' | 'grandparents'
export const OCCUPANTS: { id: Occupant; label: string; hint: string }[] = [
  { id: 'small_children', label: 'Small children', hint: 'Under 6' },
  { id: 'pre_teens', label: 'Pre-teens', hint: '6–12' },
  { id: 'teens', label: 'Teens', hint: '13–17' },
  { id: 'adult_children', label: 'Adult children', hint: '18+' },
  { id: 'adults', label: 'Adults', hint: 'Guests & parents' },
  { id: 'grandparents', label: 'Grandparents', hint: 'Easy in & out' },
]

